module.exports = __webpack_public_path__ + "static/media/z_score_blue.8a296118.svg";